/* ZINKE — Lieferzeit als Datum statt als Dauer (19.09.2026, Theme 2.8)
   4.4 (19.09.2026, Pascal: „Versteck Lieferzeit mehr“):
   - Das Zeitfenster steht nicht mehr fett als erste Vertrauenszeile, sondern
     als kleine, graue Zeile ohne Symbol am Ende der Vertrauensleiste.
     Die erste Zeile zeigt wieder nur „Versand mit Sendungsverfolgung“.
   - Kürzere Form ohne Wochentag: „Voraussichtlich bei dir: 28. Sept. – 3. Okt.“
   - Behoben: Nach einem Farbwechsel ersetzt zinke.js die Produktinfo; das
     Datum verschwand und die graue Zeile „Lieferzeit: …“ stand wieder da.
     Das Skript läuft jetzt nach jedem Austausch erneut.
   Rechtlich: Die Lieferzeit bleibt vor der Bestellung auf der Produktseite
   erkennbar (Art. 246a § 1 Nr. 7 EGBGB) — kleiner, aber nicht versteckt.
   Die volle Angabe bleibt in der Beschreibung unter „Versand und Lieferung“.
   Ausfallsicher: Ist die Angabe nicht lesbar, bleibt die alte Zeile stehen. */
(function () {
  'use strict';

  var lang = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  var fmt;
  try { fmt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' }); }
  catch (e) { fmt = new Intl.DateTimeFormat('de', { day: 'numeric', month: 'short' }); }
  var satz = {
    de: 'Voraussichtlich bei dir: {a} – {b}',
    en: 'Estimated delivery: {a} – {b}',
    fr: 'Livraison estimée : {a} – {b}',
    es: 'Entrega estimada: {a} – {b}',
    it: 'Consegna prevista: {a} – {b}',
    nl: 'Verwachte levering: {a} – {b}',
    pl: 'Przewidywana dostawa: {a} – {b}',
    sv: 'Beräknad leverans: {a} – {b}',
    da: 'Forventet levering: {a} – {b}',
    nb: 'Forventet levering: {a} – {b}',
    fi: 'Arvioitu toimitus: {a} – {b}'
  }[lang] || 'Voraussichtlich bei dir: {a} – {b}';

  function plus(tage, nurWerktage) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    if (!nurWerktage) { d.setDate(d.getDate() + tage); return d; }
    var n = 0;
    while (n < tage) {
      d.setDate(d.getDate() + 1);
      var t = d.getDay();
      if (t !== 0 && t !== 6) n++;
    }
    return d;
  }

  function anwenden() {
    var info = document.querySelector('[data-product-root] .product-info') || document.querySelector('.product-info');
    if (!info) return;
    var notes = info.querySelectorAll('.product-note');
    var note = notes.length ? notes[notes.length - 1] : null;
    var liste = info.querySelector('.product-trust');
    if (!note || !liste || liste.querySelector('.zinke-lieferdatum')) return;

    var text = (note.textContent || '').toLowerCase();
    var m = text.match(/(\d+)\s*(?:bis|to|à|a|tot|do|till|til|–|-)\s*(\d+)/);
    if (!m) return;
    var von = parseInt(m[1], 10), bis = parseInt(m[2], 10);
    if (!(von > 0 && bis >= von && bis <= 60)) return;
    var wochen = /woche|week|semaine|semana|tydz|tygod|veck|uge|uke|viiko|viikk/.test(text);
    var werktage = !wochen && /werktag|business|working|ouvr|hábil|habil|werkdag|robocz|arbetsdag|hverdag|arkip/.test(text);
    if (wochen) { von *= 7; bis *= 7; }

    var li = document.createElement('li');
    li.className = 'zinke-lieferdatum';
    li.textContent = satz.replace('{a}', fmt.format(plus(von, werktage))).replace('{b}', fmt.format(plus(bis, werktage)));
    liste.appendChild(li);
    note.hidden = true;
    note.setAttribute('data-zinke-ersetzt', '');
  }

  var stil = document.createElement('style');
  stil.textContent =
    '.product-trust li.zinke-lieferdatum{display:block;font-size:.75rem;line-height:1.4;color:var(--muted,#a5a197);padding-left:calc(20px + .6rem)}';
  document.head.appendChild(stil);

  /* 4.6: Den Block „Versand und Lieferung“ am Ende der Produktbeschreibung
     ausblenden (Lieferzeit fett im Fließtext). Die Angaben stehen weiter in
     „Versand“ (Aufklapper) und als kleine Zeile in der Vertrauensleiste. */
  function beschreibungKuerzen() {
    var rte = document.querySelector('.product-mehr .product-accordion .rte');
    if (!rte) return;
    var h = Array.prototype.filter.call(rte.querySelectorAll('h3'), function (x) {
      return /^\s*(versand|shipping|livraison|envío|envio|spedizione|verzending|wysyłka|frakt|forsendelse|levering|toimitus|toimitukset)/i.test(x.textContent || '');
    })[0];
    if (!h) return;
    var el = h;
    while (el) {
      var weiter = el.nextElementSibling;
      el.style.display = 'none';
      if (!weiter || /^H[1-3]$/.test(weiter.tagName)) break;
      el = weiter;
    }
  }
  beschreibungKuerzen();

  /* 4.6b: Versandkostenfrei-Balken (Sektion „versandhinweis“) am Handy direkt
     unter den Kaufbereich holen. Reihenfolge per CSS (zinke-produktaufbau.css). */
  function versandNachOben() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var layout = document.querySelector('[data-product-root] .product-layout');
    var hinweis = document.querySelector('.versandhinweis');
    if (!layout || !hinweis || hinweis.classList.contains('z-versand-oben')) return;
    hinweis.classList.add('z-versand-oben');
    layout.appendChild(hinweis);
  }
  versandNachOben();

  anwenden();
  var wurzel = document.querySelector('[data-product-root]');
  if (wurzel && window.MutationObserver) {
    var takt = null;
    new MutationObserver(function () {
      clearTimeout(takt);
      takt = setTimeout(anwenden, 30);
    }).observe(wurzel, { childList: true, subtree: true });
  }
})();
